/**
 * Created by Jerker Nord on 2018-04-23.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {IceIceYetiGameConfig} from "../../IceIceYetiGameConfig";
import {IceIceYetiGameModuleConfig} from "../../IceIceYetiGameModuleConfig";
import {IceIceYetiSoundConfig} from "../../IceIceYetiSoundConfig";
import {IceIceYetiReelIceController} from "../../reelice/IceIceYetiReelIceController";
import {IceIceYetiParsedGameData} from "../../server/data/IceIceYetiParsedGameData";
import {IceIceYetiParsedInitData} from "../../server/data/IceIceYetiParsedInitData";
import {IWildInfo} from "../../server/IWildInfo";

export class IceIceYetiWildAttentionController extends ReelStopPresentationController {

    private _overlayWildsBeforeSpin:boolean[][];
    private _overlaySymbolsBeforeSpin:string[][];
    private _activeGameAreaBeforeSpin:boolean[][];
    private _activeGameAreaAfterRandomTrigger:boolean[][] | null;
    private _wildInfoList:IWildInfo[];
    private _reels:string[][];
    private _isRespinScene:boolean = false;
    private _nextMode:string;
    private _isCurrentRespin:boolean;
    private _attentionWilds:StateReelSymbol[];
    private _onReelBounceTimeLines:TimelineLite[] = [new TimelineLite(), new TimelineLite(), new TimelineLite(), new TimelineLite(), new TimelineLite()];

    constructor(index:number) {
        super(index, "IceIceYetiWildAttentionController");
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_RESTORE, (event:GameEvent) => this.onRestore());
        EventHandler.addEventListener(this, SpinEvent.IDLE, (event:GameEvent) => this.onSpinIdle());
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onBeforeSpinStart());
    }

    private onRestore():void {
        for(let i:number = 0; i < this._overlayWildsBeforeSpin.length; i++) {
            for(let j:number = 0; j < this._overlayWildsBeforeSpin[i].length; j++) {
                if(this._overlayWildsBeforeSpin[i][j] == true) {
                    // Add restore sticky Wild
                    IceIceYetiGameModuleConfig.WildAttentionView.addRestoreWild([i, j], Reels.getSymbol(i, j)!);
                }
            }
        }
        if(this._nextMode === GameMode.RESPIN) {
            this.changeGameMode();
        }
    }

    private onInitDataParsed(data:IceIceYetiParsedInitData) {
        this._overlayWildsBeforeSpin = data.overlayWildsBeforeSpin;
        this._nextMode = data.nextMode;
    }

    protected parseFeatureGameData(data:IceIceYetiParsedGameData):void {
        this._overlayWildsBeforeSpin = data.overlayWildsBeforeSpin;
        this._overlaySymbolsBeforeSpin = data.overlaySymbolsBeforeSpin;
        this._wildInfoList = data.wildInfoList;
        this._activeGameAreaBeforeSpin = data.activeGameAreaBeforeSpin;
        this._activeGameAreaAfterRandomTrigger = data.activeGameAreaAfterRandomTrigger;
        this._reels = data.reels;
        this._nextMode = data.nextMode;
        this._isCurrentRespin = data.mode === GameMode.RESPIN;
    }

    private onTimeLineComplete(reelId:number, timeline:TimelineLite):void {
        this.dispatchCompleteEvent(reelId);
        if(timeline && timeline.isActive()) {
            timeline.pause();
            timeline.kill();
        }
    }

    public onReelBounce(data:IReelStoppedData):void {
        let playIceCrackingSoundWhenBehindIce:boolean = false;
        this._onReelBounceTimeLines[data.reelId] = new TimelineLite({
            paused : true,
            onComplete : () => this.onTimeLineComplete(data.reelId, this._onReelBounceTimeLines[data.reelId])
        });

        const reel:string[] = this._reels[data.reelId].slice(1, 8);
        reel.forEach((symName:string, symbolId:number) => {
            if(this._overlayWildsBeforeSpin[data.reelId][symbolId]) {
                TweenLite.to(Reels.getSymbol(data.reelId, symbolId)!, 0.1, {alpha : 0});
                IceIceYetiGameModuleConfig.WildAttentionView.addScaleDownStickyWild(data.reelId, symbolId);
                IceIceYetiGameModuleConfig.WildAttentionView.playAllScaleDownWilds(data.reelId);
            }
            if(symName === ReelSymbolName.WILD && this._overlaySymbolsBeforeSpin[data.reelId][symbolId] == null) {
                // play attention on a new wild
                const wild:StateReelSymbol | null = Reels.getSymbol(data.reelId, symbolId);
                if(wild) {
                    if(this.isOpenPositionBeforeLand(data.reelId, symbolId)) {
                        // play wild attention not behind ice.
                        this._onReelBounceTimeLines[data.reelId].add(() => {
                            SlotGame.sound.playEffect(IceIceYetiSoundConfig.instance.WILD_LANDING);
                        });
                        this._onReelBounceTimeLines[data.reelId].add(wild.changeState({
                            state : IceIceYetiGameConfig.instance.SYMBOL_STATES.land,
                            onCompleteCallback : () => wild.changeState({state : GameConfig.instance.SYMBOL_STATES.normal})
                        }), 0);
                    } else if(this.shouldPlayAttentionBehindIce(data, data.reelId, symbolId)) {
                        this._onReelBounceTimeLines[data.reelId].add(() => {
                            SlotGame.sound.playEffect(IceIceYetiSoundConfig.instance.WILD_LANDING_IN_ICE);
                        });
                        if(this._isCurrentRespin) {
                            // play normal wild attention in respin for the wild behind ice.
                            this._onReelBounceTimeLines[data.reelId].add(wild.changeState({
                                state : IceIceYetiGameConfig.instance.SYMBOL_STATES.land,
                                onCompleteCallback : () => wild.changeState({state : GameConfig.instance.SYMBOL_STATES.normal})
                            }), 0);
                        } else {
                            // play wild attention behind ice
                            const shouldPlaySound:boolean = !playIceCrackingSoundWhenBehindIce; // To not play the same sound more than one time together.
                            playIceCrackingSoundWhenBehindIce = true;
                            this._onReelBounceTimeLines[data.reelId].add(() => this._attentionWilds.push(wild));
                            this._onReelBounceTimeLines[data.reelId].add([
                                () => this.playWildLoopAttention(wild),
                                () => EventHandler.dispatchEvent(new GameEvent(IceIceYetiReelIceController.PLAY_ICE_ATTENTION, data.reelId, symbolId, shouldPlaySound))
                            ]);
                        }
                    }
                }
            }
        });

        if(data.reelId === 4) {
            if(!this._isCurrentRespin && this._nextMode === GameMode.RESPIN) {
                this.changeGameMode();
            }
            this._onReelBounceTimeLines[data.reelId].add(() => EventHandler.dispatchEvent(new GameEvent(IceIceYetiReelIceController.RESET_ALL_ICE_ATTENTION)));
            for(let j:number = 0; j < this._wildInfoList.length; j++) {
                this._onReelBounceTimeLines[data.reelId].add(IceIceYetiGameModuleConfig.WildAttentionView.getWildAnimation(this._wildInfoList[j], j, this._isCurrentRespin));
            }
            this._onReelBounceTimeLines[data.reelId].add(() => {
                while(this._attentionWilds.length > 0) {
                    const wildInIce:StateReelSymbol = this._attentionWilds.pop()!;
                    wildInIce.changeState({
                        state : GameConfig.instance.SYMBOL_STATES.normal,
                        fadeInDuration : 0.5
                    });
                }
            });
        }
        this._onReelBounceTimeLines[data.reelId].play();
    }

    private playWildLoopAttention(wild:StateReelSymbol):Timeline | null {
        return wild.changeState({
            state : IceIceYetiGameConfig.instance.SYMBOL_STATES.attentionInIce,
            replay : true,
            onCompleteCallback : () => this.playWildLoopAttention(wild)
        });
    }

    private isOpenPositionBeforeLand(reelId:number, symbolId:number):boolean {
        return this._activeGameAreaBeforeSpin[reelId][symbolId] || (this._activeGameAreaAfterRandomTrigger != null && this._activeGameAreaAfterRandomTrigger[reelId][symbolId]);
    }

    //#137
    private shouldPlayAttentionBehindIce(data:IReelStoppedData, reelId:number, symbolId:number):boolean {
        if(data.quickStop && this.isOpenPositionBeforeLand(reelId, symbolId)) {
            return true;
        }
        if(reelId === 4) {
            return false;
        }
        if(symbolId === 1 || symbolId === 5) {
            return true;
        }
        if(symbolId === 0 && this.isOpenPositionBeforeLand(reelId, 1)) {
            return true;
        }
        return symbolId === 6 && this.isOpenPositionBeforeLand(reelId, 5);
    }

    private changeGameMode():void {
        EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : this._nextMode}));
        this._isRespinScene = this._nextMode === GameMode.RESPIN;
    }

    private onSpinIdle():void {
        if(!this._isRespinScene) {
            return;
        }

        this.changeGameMode();
    }

    // when win presentations are aborted.
    private onBeforeSpinStart():void {
        this._attentionWilds = [];
        IceIceYetiGameModuleConfig.WildAttentionView.scaleUpWilds();

        if(!this._isRespinScene) {
            return;
        }

        if(this._nextMode === GameMode.NORMAL) {
            this.changeGameMode();
        }
    }
}